import { getUser } from 'app/auth/selectors';
import { connect } from 'react-redux';
import type { RouterSlice } from '../../../app-state';
import type { AuthSlice } from '../../../auth/types';
import type { UserMenuProps } from './types';
import UserMenu from './user-menu';

export const mapStateToProps = (state: AuthSlice & RouterSlice): UserMenuProps => {
  return {
    pathname: state.router.pathname,
    user: getUser(state).data
  };
};

export default connect(mapStateToProps)(UserMenu);
